import { useEffect, useRef, useState } from 'react';
import { WaveSurferInstance } from './useWaveSurferPlayer';

interface UseTimerProps {
  player?: WaveSurferInstance | null;
  isOpen: boolean;
  shouldPlay: boolean;
  isFetchingAudioSrc: boolean;
}

export const useTimer = ({
  player,
  isOpen,
  shouldPlay,
  isFetchingAudioSrc,
}: UseTimerProps) => {
  const timerRef = useRef<NodeJS.Timeout>();
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    const shouldSetInterval = player && isOpen && shouldPlay;
    const shouldClearInterval =
      (shouldSetInterval && timerRef.current) ||
      !player?.isPlaying() ||
      !isOpen ||
      isFetchingAudioSrc;

    if (shouldClearInterval) {
      clearInterval(timerRef.current);
    }

    if (shouldSetInterval) {
      timerRef.current = setInterval(() => {
        setCurrentTime(player.getCurrentTime());
      }, 500);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, player, shouldPlay, isFetchingAudioSrc]);

  return { currentTime, duration, setCurrentTime, setDuration };
};
